import { getMessageFactory } from "../getCaxaWebSocket.js";
const changeHdfFileInfo = getMessageFactory({
  code: "CHANGE_HDF_FILE_INFO"
});
export { changeHdfFileInfo };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/changeHdfFileInfo.js